import React, { FC } from "react";

interface ForbiddenPageProps {}

const ForbiddenPage: FC<ForbiddenPageProps> = () => {
  return (
    <section className="bg-white dark:bg-gray-900 ">
      <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6 flex justify-center items-center h-screen">
        <div className="mx-auto max-w-screen-sm text-center">
          <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-blue-600 dark:text-blue-500">
            403
          </h1>
          <p className="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl dark:text-white">
            Forbidden
          </p>
          <p className="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">
            You are not authorized
          </p>
          <p className="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">
            You tried to access a page you did not have prior authorization for.
          </p>
          <a
            href="/"
            className="inline-flex text-white bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-primary-900 my-4"
          >
            Back to Homepage
          </a>
        </div>
      </div>
    </section>
  );
};

export default ForbiddenPage;
